/**
 * Copy a DOM element for clipboard purposes.
 */
export const cloneElementForRichText = (element: Element) => {
  const el = element.cloneNode(true) as HTMLElement;
  el.innerHTML = element.innerHTML;
  return el;
};
